// extracted by mini-css-extract-plugin
module.exports = {"containerForCulture":"culture_containerForCulture__n9pAv"};